import eventBus from '@/services/eventBus'
import { IAlert } from './alertTile.types'

const requestAlert = (data: IAlert) => {
  eventBus.pub('alert.request', data)
}

const alertService = { requestAlert }
export default alertService
